import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { /*useDispatch,*/ useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { CardMedia, Collapse, Divider, Grid, List, ListItem } from "@material-ui/core";
import { SERVER_URL } from "../config/backend";
import "./css/footer.css";
import { faqs } from "../request/request_footer";
import { FormattedMessage } from "react-intl";
import clsx from "clsx";

const useStyles = (props) =>
    makeStyles((theme) => ({
        gridItem: {
            padding: "0px",
            margin: "0px",
        },
        punterosRedes: {
            "&:hover": {
                cursor: "pointer",
            },
        },
    }));

export default function Footer() {
    const classes = useStyles()();
    const history = useHistory();
    const globalLang = useSelector((store) => (store.user.lang === undefined ? "es" : store.user.lang));

    //-------------------------------------------------------------------------------
    //----------------------------ESTADOS--------------------------------------------
    //-------------------------------------------------------------------------------
    const [ancho, setAncho] = useState(window.screen.width);
    const [currentFaq, setCurrentFaq] = useState(0);
    const [listFaqs, setlistFaqs] = useState([]);
    const [tarjetasPagos, setTarjetasPagos] = useState([]);

    //-------------------------------------------------------------------------------
    //----------------------------FUNCIONES------------------------------------------
    //-------------------------------------------------------------------------------
    const getMetodosPagosInt = () => {
        let queryMetodosPagosInt = `query metodosPago {
            paymentMethods {
                  name
            }
        }`;
        fetch(`${SERVER_URL}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Clientid: "3iwUHcPNqqHz6AIvzhlpgHdfAfOTJVZth84BX8bh",
                Clientsecret: "ivvDiNohSNdPmyAHv2IR7yHBLp3taXpvQEuwU4CrrMULAc3dnwYVX0Ughe8Dqk1rptnBWojPbVhf25duC0NqWniH5MOOS1ryQ9LgoNeiXgWCMU4cLQAZagOuAteFrgza",
                language: globalLang,
            },
            body: JSON.stringify({
                operationName: "metodosPago",
                query: queryMetodosPagosInt,
            }),
        })
            .then((r) => r.json())
            .then((response) => {
                let auxarr = [];
//Worked here areyesarean fix: bug response["data"]["paymentMethods"] is not iterable -> response["data"]["paymentMethods"] === null
                if(response["data"]["paymentMethods"]){
                    for (const iterator of response["data"]["paymentMethods"]) {
                        auxarr.push(iterator.name.toLowerCase());
                    }
                    setTarjetasPagos(auxarr);
                }
            });
    };

    const handleClickFacebook = () => {
        var urlFacebook = "https://www.facebook.com/HNdeCuba";
        var win = window.open(urlFacebook, "_blank");
        win.focus();
    };

    const handleClickTwitter = () => {
        var urlTwitter = "https://twitter.com/HNCuba";
        var win = window.open(urlTwitter, "_blank");
        win.focus();
    };

    const handleClickInstagram = () => {
        var urlInstagram = "https://www.instagram.com/hotelnacionaldecuba/";
        var win = window.open(urlInstagram, "_blank");
        win.focus();
    };

    const handleClickTelegram = () => {
        var urlTelegram = "https://t.me/hncuba";
        var win = window.open(urlTelegram, "_blank");
        win.focus();
    };

    const handleClickYoutube = () => {
        var urlYoutube = "https://www.youtube.com/c/HotelNacionaldeCuba";
        var win = window.open(urlYoutube, "_blank");
        win.focus();
    };

    //-------------------------------------------------------------------------------
    //----------------------------VISTA----------------------------------------------
    //-------------------------------------------------------------------------------

    useEffect(() => {
        window.addEventListener("resize", function () {
            setAncho(window.screen.width);
        });
        getMetodosPagosInt();
        faqs(globalLang).then((item) => {
            if (item["faqs"].length > 0) {
                setlistFaqs(item["faqs"]);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Grid item xs={12} className="gridItem">
            <Grid container spacing={0} className="containerFooter">
                <Grid container className="marginSize">
                    <Grid container id="gridLogo">
                        <Grid item xs={4} md={5} sm={4} style={{ marginTop: "3rem" }}>
                            <Divider style={{ height: "3px", backgroundColor: "#A68A30" }} />
                        </Grid>
                        <Grid item xs={4} md={2} sm={4} style={{ marginTop: "2rem", alignItems: "center" }}>
                            <img alt="" src={require("../static/Identificador/Logo app.svg")} style={{ height: "80px", width: "40px", marginLeft: "38%", marginTop: "-1rem" }} />
                        </Grid>

                        <Grid item xs={4} md={5} sm={4} style={{ marginTop: "3rem" }}>
                            <Divider style={{ height: "3px", backgroundColor: "#A68A30" }} />
                        </Grid>
                    </Grid>

                    <Grid container style={{ marginTop: "2rem" }}></Grid>

                    <Grid container item xs={12}>
                        <Grid item container xs={12} sm={6} md={3} id="sesion1">
                            <Grid item xs={12} className="gridItemGranCaribe">
                                <CardMedia component="img" style={{ width: "25%",marginLeft:"10%" }} image={require("../static/Identificador/Gran Caribe Logo.svg")} />
                            </Grid>
                            <Grid item xs={12} className="gridPasarelaPago">
                                <div className="textoEncabezado">
                                    <FormattedMessage id="pasarelas_pago" />
                                </div>
                            </Grid>
                            <Grid item container justify="center" alignItems="center" xs={12} style={{ paddingRight: ancho < 600 ? 0 : 40 }}>
                                {/*<Grid item container justify={ancho < 600 ? "center" : "flex-start"} alignItems="center" xs={3} style={{ marginTop: "1rem" }}>
                                    <img alt="" src={require("../static/Identificador/enzona.svg")} height="30px" width="35px" />
                                </Grid>*/}
                                <Grid item container justify={ancho < 600 ? "center" : "flex-start"} alignItems="center" xs={3} style={{ marginTop: "1rem" }}>
                                    <img alt="" src={require("../static/Identificador/Transfermóvil.svg")} height="30px" width="35px" />
                                </Grid>
                                {tarjetasPagos.indexOf("American_Express".toLowerCase()) !== -1 && (
                                    <Grid item container justify={ancho < 600 ? "center" : "flex-start"} alignItems="center" xs={3} style={{ marginTop: "1rem" }}>
                                        <img alt="" src={require("../static/Identificador/American_Express.svg")} height="30px" width="35px" />
                                    </Grid>
                                )}
                                {tarjetasPagos.indexOf("Dinners_Club_International".toLowerCase()) !== -1 && (
                                    <Grid item container justify={ancho < 600 ? "center" : "flex-start"} alignItems="center" xs={3} style={{ marginTop: "1rem" }}>
                                        <img alt="" src={require("../static/Identificador/Diners_Club.svg")} height="30px" width="35px" />
                                    </Grid>
                                )}
                                {tarjetasPagos.indexOf("Mastercard_Maestro".toLowerCase()) !== -1 && (
                                    <Grid item container justify={ancho < 600 ? "center" : "flex-start"} alignItems="center" xs={3} style={{ marginTop: "1rem" }}>
                                        <img alt="" src={require("../static/Identificador/Maestro.svg")} height="30px" width="35px" />
                                    </Grid>
                                )}
                                {tarjetasPagos.indexOf("Visa_Electron".toLowerCase()) !== -1 && (
                                    <Grid item container justify={ancho < 600 ? "center" : "flex-start"} alignItems="center" xs={3} style={{ marginTop: "1rem" }}>
                                        <img alt="" src={require("../static/Identificador/Visa_Electron.svg")} height="30px" width="35px" />
                                    </Grid>
                                )}
                                {tarjetasPagos.indexOf("Tarjeta_Virtual".toLowerCase()) !== -1 && (
                                    <Grid item container justify={ancho < 600 ? "center" : "flex-start"} alignItems="center" xs={3} style={{ marginTop: "1rem" }}>
                                        <img alt="" src={require("../static/Identificador/Tarjeta_Virtual.svg")} height="30px" width="35px" />
                                    </Grid>
                                )}
                                {tarjetasPagos.indexOf("Bizum".toLowerCase()) !== -1 && (
                                    <Grid item container justify={ancho < 600 ? "center" : "flex-start"} alignItems="center" xs={3} style={{ marginTop: "1rem" }}>
                                        <img alt="" src={require("../static/Identificador/Bizum.svg")} height="30px" width="35px" />
                                    </Grid>
                                )}
                                {tarjetasPagos.indexOf("Iupay".toLowerCase()) !== -1 && (
                                    <Grid item container justify={ancho < 600 ? "center" : "flex-start"} alignItems="center" xs={3} style={{ marginTop: "1rem" }}>
                                        <img alt="" src={require("../static/Identificador/Iupay.svg")} height="30px" width="35px" />
                                    </Grid>
                                )}
                                {tarjetasPagos.indexOf("Discover_Global".toLowerCase()) !== -1 && (
                                    <Grid item container justify={ancho < 600 ? "center" : "flex-start"} alignItems="center" xs={3} style={{ marginTop: "1rem" }}>
                                        <img alt="" src={require("../static/Identificador/Discover_Card.svg")} height="30px" width="35px" />
                                    </Grid>
                                )}
                                {tarjetasPagos.indexOf("Union_Pay".toLowerCase()) !== -1 && (
                                    <Grid item container justify={ancho < 600 ? "center" : "flex-start"} alignItems="center" xs={3} style={{ marginTop: "1rem" }}>
                                        <img alt="" src={require("../static/Identificador/Union_Pay.svg")} height="30px" width="35px" />
                                    </Grid>
                                )}
                                {/*{tarjetasPagos.indexOf("VISA".toLowerCase()) !== -1 && (*/}
                                    <Grid item container justify={ancho < 600 ? "center" : "flex-start"} alignItems="center" xs={3} style={{ marginTop: "1rem" }}>
                                        <img alt="" src={require("../static/Identificador/Visa.svg")} height="30px" width="35px" />
                                    </Grid>
                                {/*})}*/}
                                {/*{tarjetasPagos.indexOf("MASTERCARD".toLowerCase()) !== -1 && (*/}
                                    <Grid item container justify={ancho < 600 ? "center" : "flex-start"} alignItems="center" xs={3} style={{ marginTop: "1rem" }}>
                                        <img alt="" src={require("../static/Identificador/Mastercard.svg")} height="30px" width="35px" />
                                    </Grid>
                                {/*)}*/}
                            </Grid>
                            <Grid container style={{ marginTop: "2rem" }}></Grid>
                        </Grid>

                        <Grid item container xs={12} sm={6} md={2} id="sesion2">
                            <Grid container className="gridItemContacto">
                                <Grid item xs={12} sm={12} md={12}>
                                    <div className="textoEncabezado">
                                        <FormattedMessage id="contactos" />
                                    </div>
                                </Grid>
                                <Grid item xs={1} sm={1} md={2}  style={{ marginTop: "1rem" }}>
                                    <CardMedia component="img" style={{ height: "25px", width: "20px" }} image={require("../static/Íconos/map-pin.svg")} />
                                </Grid>
                                <Grid item xs={11} sm={11} md={10}  style={{ marginTop: "1rem"}}>
                                    <div className="texto">
                                        <FormattedMessage id="footer_direccion_uno" />
                                        <br />
                                        <FormattedMessage id="footer_direccion_dos" />
                                    </div>
                                </Grid>
                                <Grid item xs={1} sm={1} md={2} style={{ marginTop: "1rem" }}>
                                    <CardMedia component="img" style={{ height: "20px", width: "20px" }} image={require("../static/Íconos/phone-call dorado.svg")} />
                                </Grid>
                                <Grid item xs={11} sm={11} md={10} style={{ marginTop: "1rem"}}>
                                    <div className="texto">(+53) 7 836 3564</div>
                                </Grid>
                                <Grid item xs={1} sm={1} md={2} style={{ marginTop: "1rem" }}>
                                    <CardMedia component="img" style={{ height: "20px", width: "25px" }} image={require("../static/Íconos/mail.svg")} />
                                </Grid>
                                <Grid item xs={11} sm={11} md={10} style={{ marginTop: "1rem" }}>
                                    <div className="texto">webmaster@gcnacio.gca.tur.cu</div>
                                </Grid>
                                <Grid item container justify="center" alignItems="center" xs={12} style={{ paddingRight: ancho < 600 ? 40 : 0 }}>
                                    <Grid item xs={2} style={{ marginTop: "1rem" }}>
                                        <img alt="" className={classes.punterosRedes} src={require("../static/Íconos/facebook-1.svg")} height="16px" width="10px" onClick={handleClickFacebook} />
                                    </Grid>

                                    <Grid item xs={2} style={{ marginTop: "1rem" }}>
                                        <img alt="" className={classes.punterosRedes} src={require("../static/Íconos/twitter.svg")} height="15px" width="17px" onClick={handleClickTwitter} />
                                    </Grid>

                                    <Grid item xs={2} style={{ marginTop: "1rem" }}>
                                        <img alt="" className={classes.punterosRedes} src={require("../static/Íconos/Instagram.svg")} height="15px" width="15px" onClick={handleClickInstagram} />
                                    </Grid>

                                    <Grid item xs={2} style={{ marginTop: "1rem" }}>
                                        <img alt="" className={classes.punterosRedes} src={require("../static/Íconos/Telegram.svg")} height="15px" width="15px" onClick={handleClickTelegram} />
                                    </Grid>

                                    <Grid item xs={2} style={{ marginTop: "1rem" }}>
                                        <img alt="" className={classes.punterosRedes} src={require("../static/Íconos/youtube.svg")} height="15px" width="15px" onClick={handleClickYoutube} />
                                    </Grid>
                                    <Grid item xs={2} style={{ marginTop: "1rem" }}>
                                        <img alt="" className={classes.punterosRedes} src={require("../static/Íconos/Whatsapp-01.svg")} height="15px" width="15px" onClick={() => {}} />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container style={{ marginTop: "2rem" }}></Grid>
                        </Grid>

                        <Grid item container xs={12} sm={6} md={2} id="sesion3">
                            <Grid container className="gridItemMenu">
                                <Grid item xs={12} sm={12} md={12}>
                                    <div className="textoEncabezado">
                                        <FormattedMessage id="menu" />
                                    </div>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} style={{ marginTop: "1rem" }}>
                                    <div
                                        className={clsx("texto", classes.punterosRedes)}
                                        onClick={() => {
                                            history.push("/");
                                        }}
                                    >
                                        <FormattedMessage id="footer_inicio" />
                                    </div>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} style={{ marginTop: "1rem" }}>
                                    <div
                                        className={clsx("texto", classes.punterosRedes)}
                                        onClick={() => {
                                            history.push("/promociones");
                                        }}
                                    >
                                        <FormattedMessage id="footer_ofertas" />
                                    </div>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} style={{ marginTop: "0.75rem" }}>
                                    <div
                                        className={clsx("texto", classes.punterosRedes)}
                                        onClick={() => {
                                            var urlEventos = "https://eventos.hotelnacional.tur.cu/";
                                            var win = window.open(urlEventos, "_blank");
                                            win.focus();
                                        }}
                                    >
                                        <FormattedMessage id="footer_eventos" />
                                    </div>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} style={{ marginTop: "0.9rem" }}>
                                    <div
                                        className={clsx("texto", classes.punterosRedes)}
                                        onClick={() => {
                                            history.push("/habitaciones");
                                        }}
                                    >
                                        <FormattedMessage id="footer_habitaciones" />
                                    </div>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} style={{ marginTop: "0.9rem" }}>
                                    <div
                                        className={clsx("texto", classes.punterosRedes)}
                                        onClick={() => {
                                            history.push("/cabaret_parisien");
                                        }}
                                    >
                                        <FormattedMessage id="footer_cabaret" />
                                    </div>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} style={{ marginTop: "0.9rem" }}>
                                    <div
                                        className={clsx("texto", classes.punterosRedes)}
                                        onClick={() => {
                                            history.push("/historia");
                                        }}
                                    >
                                        <FormattedMessage id="footer_historia" />
                                    </div>
                                </Grid>
                                {/* <Grid item xs={6} sm={6} md={6} style={{ marginTop: "0.9rem" }}>
                                    <div className={clsx("texto", classes.punterosRedes)}>
                                        <FormattedMessage id="footer_sobre_hnc" />
                                    </div>
                                </Grid> */}
                            </Grid>
                            <Grid container style={{ marginTop: "2rem" }}></Grid>
                        </Grid>

                        <Grid item container xs={12} sm={6} md={2} id="sesion4">
                            <Grid container className="gridItemMenu">
                                <Grid item xs={12} sm={12} md={12}>
                                    <div className="textoEncabezado">
                                        <FormattedMessage id="acerca_hnc" />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} style={{ marginTop: "0.75rem" }}>
                                    <div
                                        className={clsx("texto", classes.punterosRedes)}
                                        onClick={() => {
                                            history.push("/quienes_somos");
                                        }}
                                    >
                                        <FormattedMessage id="footer_quienes_somos" />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} style={{ marginTop: "0.75rem" }}>
                                    <div
                                        className={clsx("texto", classes.punterosRedes)}
                                        onClick={() => {
                                            history.push("/legales/politica_privacidad");
                                        }}
                                    >
                                        <FormattedMessage id="footer_politica_privacidad" />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} style={{ marginTop: "0.75rem" }}>
                                    <div
                                        className={clsx("texto", classes.punterosRedes)}
                                        onClick={() => {
                                            history.push("/legales/terminos_condiciones");
                                        }}
                                    >
                                        <FormattedMessage id="footer_terminos_condiciones" />
                                    </div>
                                </Grid>
                                {/* <Grid item xs={4} sm={4} md={4} style={{ marginTop: "2rem" }}>
                                    <CardMedia component="img" style={{ height: "40px", width: "40px" }} image={require("../static/Íconos/Mapa.svg")} />
                                </Grid>
                                <Grid item xs={4} sm={4} md={4} style={{ marginTop: "2rem" }}>
                                    <CardMedia component="img" style={{ height: "40px", width: "40px" }} image={require("../static/Íconos/Chat button.svg")} />
                                </Grid> */}
                            </Grid>
                            <Grid container style={{ marginTop: "2rem" }}></Grid>
                        </Grid>

                        <Grid item container xs={12} sm={6} md={3} id="sesion5">
                            <Grid container className="gridItemMenu">
                                <Grid item xs={12}>
                                    <div className="textoEncabezado">
                                        <FormattedMessage id="preguntas_frecuentes" />
                                    </div>
                                </Grid>
                                <Grid item xs={12} style={{ paddingRight: ancho < 600 ? 70 : 0 }}>
                                    <List component="nav" aria-labelledby="nested-list-subheader">
                                        {listFaqs.map((item) => (
                                            <React.Fragment key={parseInt(item.id)}>
                                                <ListItem
                                                    button
                                                    onClick={() => {
                                                        if (currentFaq === parseInt(item.id)) {
                                                            setCurrentFaq(0);
                                                        } else {
                                                            setCurrentFaq(parseInt(item.id));
                                                        }
                                                    }}
                                                >
                                                    <Grid item xs={11}>
                                                        <div className="textoPreguntas">{item.question} </div>
                                                    </Grid>
                                                    <Grid item xs={1} style={{ display: "flex", justifyContent: "flex-end" }}>
                                                        {currentFaq === parseInt(item.id) ? <img alt="more" src={require("../static/Íconos/arrow-right.svg")} /> : <img alt="more" src={require("../static/Íconos/arrow-down.svg")} />}
                                                    </Grid>
                                                </ListItem>
                                                <Collapse in={currentFaq === parseInt(item.id) ? true : false} timeout="auto" unmountOnExit>
                                                    <div className="textoPreguntas" style={{ paddingLeft: 25 }}>
                                                        {item.answer}
                                                    </div>
                                                </Collapse>
                                                <Divider className="divider" />
                                            </React.Fragment>
                                        ))}
                                    </List>
                                </Grid>
                            </Grid>
                            <Grid container style={{ marginTop: "2rem" }}></Grid>
                        </Grid>
                    </Grid>

                    <Grid container style={{ marginTop: "3rem" }}></Grid>
                </Grid>

                <Grid
                    container
                    style={{
                        backgroundColor: "#A68A30",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <div className="textoCopyRight">
                        © {new Date().getFullYear()}. <FormattedMessage id="desarrollado_d_click_solucion" />
                    </div>
                </Grid>
            </Grid>
        </Grid>
    );
}
